import { createContext, useContext, useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";

const SocketContext = createContext({
  socket: null,
  socketId: null,
});

export const SocketProvider = ({ children }) => {
  const [socketId, setSocketId] = useState(null);
  const socketRef = useRef(null);

  const dataUser = getLocalStorage(dataLocalStorage.userinfo);
  const token = dataUser.token;

  useEffect(() => {
    // Only create a new socket if one doesn't exist
    if (!socketRef.current) {
      socketRef.current = io(
        `${process.env.REACT_APP_BASEURLSOCKET}?token=${token}`,
        {
          transports: ["websocket"],
          secure: true,
          reconnection: true,
          reconnectionAttempts: 10,
          reconnectionDelay: 2000,
        }
      );

      // Set up event listeners
      socketRef.current.on("connect", () => {
        // console.log("Socket connected with ID:", socketRef.current?.id);
        setSocketId(socketRef.current?.id || null);
      });

      socketRef.current.on("connect_error", (err) => {
        console.error("Socket connection error:", err);
      });
    }

    // Cleanup function
    return () => {
      if (socketRef.current) {
        socketRef.current.removeAllListeners();
        socketRef.current.close();
        socketRef.current = null;
        setSocketId(null);
      }
    };
  }, []); // Empty dependency array means this only runs once on mount

  return (
    <SocketContext.Provider
      value={{
        socket: socketRef.current,
        socketId,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
